module.exports = __webpack_public_path__ + "img/kp-logo-reverse.a2bf7d47.svg";